import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const SignUpWrapper = ({ children }) => {
  const tempAccessToken = localStorage.getItem('access_token_temp');
  const isLoggedIn = tempAccessToken !== null;

  const location = useLocation();

  return !isLoggedIn ? <Navigate to='/login' state={{ from: location.pathname }} /> : children;
};

export default SignUpWrapper;
